import React from 'react';
import styled from 'styled-components/macro';


const StyledInput = styled.input`
  color: ${ ({
    error,
    theme,
  }) => (
          error ? theme.red1 : theme.text1
  ) };
  width: 0;
  position: relative;
  font-weight: 500;
  outline: none;
  border: none;
  flex: 1 1 auto;
  background-color: ${ ({ theme }) => theme.bg1 };
  font-size: ${ ({ fontSize }) => fontSize ?? '20px' };
  text-align: ${ ({ align }) => align && align };
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 5px;
  -webkit-appearance: textfield;

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  [type='number'] {
    -moz-appearance: textfield;
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  ::placeholder {
    color: ${ ({ theme }) => theme.text4 };
  }
`;

export const TextInput = React.memo(function InnerInput({
  value,
  onUserInput,
  placeholder,
  prependSymbol,
  minLength,
  maxLength,
  ...rest
}) {
  const enforcer = (nextUserInput) => {
    onUserInput(nextUserInput);
    //if (nextUserInput === '' ) { // || isAddress(nextUserInput)
     
    //}
  };

  return (
    <StyledInput
      { ...rest }
      value={ value }
      onChange={ (event) => {
          enforcer(event.target.value);
      } }
      // universal input options
      inputMode="text"
      autoComplete="off"
      autoCorrect="off"
      type="text"
      placeholder={ placeholder || ' ' }
      minLength={ minLength || 42 }
      maxLength={ maxLength ||  42 }
      spellCheck="false"
    />
  );
});

export default TextInput;

// const inputRegex = RegExp(`^\\d*(?:\\\\[.])?\\d*$`) // match escaped "." characters via in a non-capturing group
